module.exports = __webpack_public_path__ + "images/6270a2d4757a839d4653c02f3db32e2f.svg";